'use client';

import { useState } from 'react';

/**
 * `value` as it was on the render `holding` turned true, until `holding` turns
 * false again; `value` itself otherwise. Lets a view keep painting the data it
 * had when a transition started while the source keeps updating underneath.
 */
export function useHeldWhile(value, holding) {
  const [held, setHeld] = useState(null);
  if (holding && held === null) {
    setHeld({
      value
    });
  }
  if (!holding && held !== null) {
    setHeld(null);
  }
  return holding && held !== null ? held.value : value;
}